import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@yola/ws-ui';
import { contentEditable, textFormatting, view } from '@yola/ws-sdk';
import useFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hooks/use-feature-flags';
import Trigger from 'src/js/modules/common/components/trigger';
import withSelection from 'src/js/modules/utils/with-selection';
import getBreakpointForCurrentDevice from 'src/js/modules/breakpoint-editing/helpers/get-breakpoint-for-current-device';
import { DESKTOP_ONLY_BREAKPOINT } from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import restoreRange from '../helpers/restore-range';
import clearFormatting from '../helpers/clear-formatting';

const { breakpointModifiers } = view;

const ClearFormattingTrigger = ({
  icon,
  elementId,
  triggerId,
  getTooltip = Function.prototype,
  getContext,
}) => {
  const [featureFlags] = useFeatureFlags(['breakpoint_editing']);
  const { breakpoint_editing: isBreakpointEditingEnabled } = featureFlags;
  const activeBreakpoint = isBreakpointEditingEnabled
    ? getBreakpointForCurrentDevice(breakpointModifiers.ONLY)
    : DESKTOP_ONLY_BREAKPOINT;

  const handleClick = () => {
    const selection = textFormatting.accessors.getAdvancedSelection();
    restoreRange(selection, elementId);

    contentEditable.operations.addCheckpoint();
    clearFormatting(selection, elementId, activeBreakpoint);

    if (selection.isCollapsed) {
      const { controlPane } = getContext();
      controlPane.forceControlPaneRerender();
    }
  };
  return (
    <Trigger id={triggerId} data-tip={getTooltip()} onClick={handleClick}>
      <Icon glyph={icon} size="16" strokeWidth="1.8" />
    </Trigger>
  );
};

ClearFormattingTrigger.propTypes = {
  icon: PropTypes.string.isRequired,
  triggerId: PropTypes.string.isRequired,
  elementId: PropTypes.string.isRequired,
  getTooltip: PropTypes.func,
  getContext: PropTypes.func.isRequired,
};

export default withSelection(ClearFormattingTrigger);
